import { useEffect, useState } from "react";
import { getBranding } from "@/lib/api";

export default function useBranding() {
  const [b, setB] = useState({ name: "", username: "" });
  useEffect(() => { getBranding().then((d) => setB({ ...d, name: (d.name || "").replace(/_/g, " ") })).catch(() => {}); }, []);
  return b;
}
